module.exports = {
    date: 'date',
    enum: 'enum',
    string: 'string',
    multiSelectEnum: 'multiSelectEnum',
    radioChoiceEnum: 'radioChoiceEnum',
    lookup: 'lookup'
};
